import { OwnershipSplitType } from '@app/shared/models/contracts/enums/shared-enums';
import { FORM_FIELD_NAMES, getManualFieldName } from '../formFieldNames';
import { TableSection } from '../types';

/**
 * Gets the appropriate form field name based on context
 */
export const getFieldName = (
  isProRata: boolean,
  renderingSplitType: OwnershipSplitType,
  tableSection: TableSection,
  ownershipIndex: number
) => {
  const isProRataSelected = isProRata && renderingSplitType === OwnershipSplitType.ProRata;
  const isManualSelected = !isProRata && renderingSplitType === OwnershipSplitType.Manual;

  const validCase = isProRataSelected || isManualSelected;
  if (!validCase) {
    return '';
  }

  if (tableSection === TableSection.RealBuybackValue) {
    return isProRata
      ? 'proRataRealBuybackAmount'
      : `ownership[${ownershipIndex}].realBuybackAmount`;
  }

  if (isProRataSelected) {
    switch (tableSection) {
      case TableSection.AmountAdjustment:
        return FORM_FIELD_NAMES.PRO_RATA_AMOUNT;
      case TableSection.SharesAdjustment:
        return FORM_FIELD_NAMES.PRO_RATA_SHARES;
      case TableSection.AmountClosingBalance:
        return FORM_FIELD_NAMES.PRO_RATA_CLOSING_AMOUNT;
      case TableSection.SharesClosingBalance:
        return FORM_FIELD_NAMES.PRO_RATA_CLOSING_SHARES;
      default:
        return '';
    }
  }
  // Manual selected
  switch (tableSection) {
    case TableSection.AmountAdjustment:
      return getManualFieldName(ownershipIndex, FORM_FIELD_NAMES.MANUAL_AMOUNT);
    case TableSection.SharesAdjustment:
      return getManualFieldName(ownershipIndex, FORM_FIELD_NAMES.MANUAL_SHARES);
    case TableSection.AmountClosingBalance:
      return getManualFieldName(ownershipIndex, FORM_FIELD_NAMES.MANUAL_CLOSING_AMOUNT);
    case TableSection.SharesClosingBalance:
      return getManualFieldName(ownershipIndex, FORM_FIELD_NAMES.MANUAL_CLOSING_SHARES);
    default:
      return '';
  }
};
